//
// import SymptomsTrackerPage from "./SymptomsTrackerIndexPage";
import React from "react";
import Header from "../../components/Header/Header";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Footer from "../../components/Footer/Footer";
// import ConditionsPage from "./conditionsPage";
import SymptomScoringFlow from "./SymptomScoringFlow";

function Index() {
  // const [index, setIndex] = useState(1);
  const isLoggedIn = Boolean(
    typeof window !== "undefined" &&
      (localStorage.getItem("token"))
  );
  return (
    <div>
      {isLoggedIn ? <Header /> : <PreLoginHeader />}
      <div className="profile-setup-container">
        <div className="bg-blob bg-blob-1"></div>
        <div className="bg-blob bg-blob-2"></div>
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        {/* {index === 1 && <SymptomsTrackerPage setIndex={setIndex} />}
        {index === 2 && <ConditionsPage />} */}
        <SymptomScoringFlow />
      </div>
      <Footer />
    </div>
  );
}

export default Index;
